module.exports = __webpack_public_path__ + "static/media/uc_race_time.c6f98a05.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/uc_race_time.png
// module id = 365
// module chunks = 0